import { Injectable } from '@angular/core';
import { AbstractSandbox } from 'app/core/sandboxes/abstract.sandbox';
import * as flowsActions from 'app/core/store/flows/flows.actions';
import { Observable } from 'rxjs';
import { FilterValuesService } from '../services/filter-values.service';

@Injectable({ providedIn: 'root' })
export class FlowsSandbox extends AbstractSandbox {
  constructor(private filterValuesService: FilterValuesService) {
    super();
  }

  resetFlowsFilterValues(): void {
    this.store.dispatch(new flowsActions.FlowsFilterValuesResetAction());
  }

  loadFlowsFilterValues(): Observable<void> {
    return this.filterValuesService.loadFlowsFilterValues(this.handleFail.bind(this));
  }
}
